export const KANBAN_DRAGGING_CURSOR_CLASS = "kanban-dragging-cursor";
export const KANBAN_CARD_DRAGGING_CLASS = "kanban-card-dragging";
export const KANBAN_CARD_DRAG_CURSOR_SELECTOR = "article.react-trello-card";
export const KANBAN_LANE_DRAG_CURSOR_SELECTOR = ".react-trello-lane > header";
export const KANBAN_DRAG_CURSOR_BLOCKED_SELECTOR = [
  "input",
  "textarea",
  "select",
  "[contenteditable='true']",
  "[contenteditable='']",
  "button",
  "a[href]",
  "[role='button']",
  ".MuiButtonBase-root",
  ".kanban-card-action-target",
  ".kanban-lane-header-actions"
].join(", ");

const getCursorRoots = (doc = document) =>
  [doc?.documentElement, doc?.body].filter(Boolean);

export const setKanbanDraggingCursor = (active, doc = document) => {
  getCursorRoots(doc).forEach((element) => {
    element.classList.toggle(KANBAN_DRAGGING_CURSOR_CLASS, Boolean(active));
  });
};

export const clearKanbanDraggingCursor = (doc = document) => {
  setKanbanDraggingCursor(false, doc);
};

export const installKanbanDraggingCursorCleanup = (
  doc = typeof document !== "undefined" ? document : null,
  win = typeof window !== "undefined" ? window : undefined
) => {
  if (!doc) return () => {};

  const clearCursor = () => clearKanbanDraggingCursor(doc);
  const targetWindow = win || doc.defaultView;

  clearCursor();

  const documentEvents = [
    "mouseup",
    "pointerup",
    "pointercancel",
    "dragend",
    "touchend",
    "touchcancel",
    "visibilitychange"
  ];
  const windowEvents = ["blur", "pagehide", "pageshow"];

  documentEvents.forEach((eventName) => {
    doc.addEventListener(eventName, clearCursor, true);
  });

  if (targetWindow?.addEventListener) {
    windowEvents.forEach((eventName) => {
      targetWindow.addEventListener(eventName, clearCursor);
    });
  }

  return () => {
    documentEvents.forEach((eventName) => {
      doc.removeEventListener(eventName, clearCursor, true);
    });

    if (targetWindow?.removeEventListener) {
      windowEvents.forEach((eventName) => {
        targetWindow.removeEventListener(eventName, clearCursor);
      });
    }
  };
};

export const shouldActivateKanbanDraggingCursor = (
  event,
  {
    cardSelector = KANBAN_CARD_DRAG_CURSOR_SELECTOR,
    laneSelector = KANBAN_LANE_DRAG_CURSOR_SELECTOR,
    blockedSelector = KANBAN_DRAG_CURSOR_BLOCKED_SELECTOR,
    laneDraggable = false
  } = {}
) => {
  if (!event || (event.button !== undefined && event.button !== 0)) return false;

  const target = event.target;
  if (!target?.closest) return false;

  const cardElement = target.closest(cardSelector);
  const laneHeaderElement = target.closest(laneSelector);
  const blockedElement = target.closest(blockedSelector);

  if (
    blockedElement &&
    blockedElement !== cardElement &&
    blockedElement !== laneHeaderElement
  ) {
    return false;
  }

  if (cardElement) return true;

  return Boolean(laneDraggable && laneHeaderElement);
};
